import { render, staticRenderFns } from "./Tresult.vue?vue&type=template&id=22b04bc7"
import script from "./Tresult.vue?vue&type=script&lang=js"
export * from "./Tresult.vue?vue&type=script&lang=js"
import style0 from "./Tresult.vue?vue&type=style&index=0&id=22b04bc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports